// Small UI primitives reused across the Operator Console.
import { STATUS_META } from "./mockData";

const TONE = {
  emerald: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  amber: "bg-amber-50 text-amber-800 ring-amber-600/30",
  sky: "bg-sky-50 text-sky-700 ring-sky-600/20",
  slate: "bg-slate-100 text-slate-700 ring-slate-500/20",
  rose: "bg-rose-50 text-rose-700 ring-rose-600/20",
};

export const StatusPill = ({ status, testId }) => {
  const meta = STATUS_META[status] || { label: status, tone: "slate" };
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${TONE[meta.tone]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full bg-current opacity-70`} />
      {meta.label}
    </span>
  );
};

export const MockBanner = () => (
  <div
    data-testid="operator-console-mock-banner"
    className="bg-amber-50 border-b border-amber-200 text-amber-900 text-xs px-4 py-2 flex items-center gap-2"
  >
    <span className="inline-flex h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" />
    <span className="font-medium uppercase tracking-wide">Phase 2C — partial live</span>
    <span className="text-amber-800/80">
      Platform Health, Feature Flags, Companies, Stores, Departments, Users, Stats, Action History, Catalog Imports, and Store Coverage are <strong>live</strong>. Revenue, Pipeline, Tasks, Billing, Wizard, Onboarding, Contacts, and Notes remain <strong>mock — Phase 2D+</strong>.
    </span>
  </div>
);

export const SectionHeader = ({ title, subtitle, right, testId }) => (
  <div className="flex items-end justify-between gap-4 mb-4" data-testid={testId}>
    <div>
      <h2 className="text-lg font-semibold text-slate-900 tracking-tight">{title}</h2>
      {subtitle && (
        <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>
      )}
    </div>
    {right}
  </div>
);

export const Stat = ({ label, value, sub, testId }) => (
  <div
    data-testid={testId}
    className="rounded-lg border border-slate-200 bg-white p-4"
  >
    <div className="text-xs uppercase tracking-wide text-slate-500">{label}</div>
    <div className="mt-1 text-2xl font-semibold text-slate-900 tabular-nums">
      {value}
    </div>
    {sub && <div className="mt-0.5 text-xs text-slate-500">{sub}</div>}
  </div>
);
